// extracted by mini-css-extract-plugin
export var heroImage = "_lm-1";
export var modal = "_lm-0";